import { createStyles, makeStyles } from '@material-ui/core';
import { Forum } from '@material-ui/icons';
import clsx from 'clsx';
import React from 'react';
import { useLocalization, useViewerState } from "../../hooks/index.js";
import { ToggleBase } from "./toggle-base.js";
const useStyles = makeStyles(theme => {
  return createStyles({
    iconButton: {},
    icon: {},
    iconActive: {
      fill: theme.palette.primary.main
    }
  });
});
/**
 * Represents a comment toggler component
 */
export const ToggleCommentsWidget = props => {
  const classes = useStyles(props);
  const localization = useLocalization();
  const viewerState = useViewerState();
  return /*#__PURE__*/React.createElement(ToggleBase, {
    classes: classes,
    active: viewerState.showComments,
    title: localization.toggleComments,
    setValue: v => viewerState.updateState({
      showComments: v
    })
  }, /*#__PURE__*/React.createElement(Forum, {
    className: clsx(classes.icon, {
      [classes.iconActive]: viewerState.showComments
    })
  }));
};
//# sourceMappingURL=toggle-comments.js.map